import { Component, OnInit } from '@angular/core';
import { Page } from '../../models/pages/page';
import { PagesService } from '../../services/pages.service';

@Component({
  selector: 'app-save-word',
  templateUrl: './save-word.component.html',
  styleUrls: ['./save-word.component.scss']
})
export class SaveWordComponent implements OnInit {
  public textValue: string = '';
  public page: Page;
  private _sendBlockTime: number = 0;
  private _interval: any;

  constructor(
    private _pagesService: PagesService
  ) { }

  ngOnInit(): void {
    this._pagesService.getData({slug: 'propozycje'}).subscribe(
      response => this.page = new Page(response),
      error => {
        this.page = new Page({});
      }
    );
  }

  public sendValue() {
    if (this.buttonDisabled()) { return false; }
    if (!this.textValue) { return false;}  
    this._pagesService.sendComments(
      {
        content: this.textValue,
        post: this.page.id
      }
    ).subscribe(
      response => {
        this._sendBlockTime = 10;
        this._interval = setInterval(() => { 
          this._reduceBlockTime(); 
        }, 1000);
      },
      error => {
        console.log(error);
      }
    );   
  }

  public buttonDisabled() {
    return (this._sendBlockTime > 0);
  }

  private _reduceBlockTime() {
    this._sendBlockTime--;
    if (this._sendBlockTime < 0) {
      clearInterval(this._interval);
    }
  }
}
